import React from 'react'
import { GalleryItemModel } from './Gallery.model'

type GalleryThumbnailProps = {
    items: GalleryItemModel[]
    handleOnClick: (selectedIndex: number) => void
}

const GalleryThumbnail = ({ items, handleOnClick }: GalleryThumbnailProps) => {
    if(!items) return null

    return (
        <div className='flex space-x-3'>
            {items?.map((_, index) => (
                <button
                    key={_?.id}
                    className='w-[60px] h-[60px] rounded-lg overflow-hidden'
                    onClick={()=> handleOnClick(index)}
                >
                    <img src={_?.thumbnail} alt={_.title} className='w-full' />
                </button>
            ))}
        </div>
    )
}

export default GalleryThumbnail